/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="61.19"
        height="95.58"
        viewBox="0 0 61.19 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M51 0a1.24 1.24 0 0 1 1.16.8v.12l3.07 11.15-2.41.66L50 2.5H11.18L8.37 12.73 6 12.07 9 .92A1.25 1.25 0 0 1 10.1 0H51Z"
          fill="#0e497b"
          className="icon-fill icon-base"/><path
          d="M57.74 11.15H3.44a1.25 1.25 0 0 0-1.21.92L0 20.25a1.25 1.25 0 0 0 1.21 1.57H59.9a1.24 1.24 0 0 0 1.2-1.57L59 12.07a1.25 1.25 0 0 0-1.26-.92Zm-1 2.5 1.53 5.67H2.88l1.52-5.67Z"
          fill="#0e497b"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M56 19.32a1.25 1.25 0 0 1 1.25 1.28v.13l-2 15.05-2.48-.32 1.78-13.64h-48L8.4 35.46l-2.48.32L4 20.73a1.25 1.25 0 0 1 1.11-1.4H56ZM47.65 74.76l2.48.32-2.53 19.41a1.26 1.26 0 0 1-1.12 1.09H14.83a1.24 1.24 0 0 1-1.22-1v-.13l-2.54-19.41 2.48-.32 2.39 18.32h29.32Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M56 34.37H5.19A1.25 1.25 0 0 0 4 35.76l4.33 39.29a1.25 1.25 0 0 0 1.24 1.12h42.09a1.26 1.26 0 0 0 1.25-1.12l4.33-39.29A1.26 1.26 0 0 0 56 34.37Zm-1.39 2.5-4.06 36.8H10.64l-4-36.8Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'CoffeeCupDisposableIcon';

export default Icon;
